// extracted by mini-css-extract-plugin
export default {"setting-container":"modeTwoSelect_setting-container__kkkpX","setting":"modeTwoSelect_setting__EHaCT"};